import { COMPANY } from '@shared/config';

import { absoluteUrl, type SeoPage } from './metadata';

const organization = {
  '@type': 'Organization',
  '@id': `${COMPANY.site}/#organization`,
  name: COMPANY.brand,
  legalName: COMPANY.operator,
  url: COMPANY.site,
  logo: absoluteUrl('/icons/icon-512x512.png'),
  telephone: COMPANY.phone,
  email: COMPANY.email,
  taxID: COMPANY.inn,
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'RU',
    addressLocality: COMPANY.city,
    streetAddress: 'ул. Зверева, 22',
  },
};

export const STATIC_SEO_PAGES: SeoPage[] = [
  {
    path: '/',
    title: 'Уличное спортивное оборудование от производителя — РПСО',
    description:
      'РПСО — производитель спортивного оборудования в Иванове. Уличные тренажёры, спортивные и умные площадки. Каталог, фотографии выполненных объектов, запрос КП.',
    schema: [
      organization,
      { '@type': 'WebSite', '@id': `${COMPANY.site}/#website`, name: 'РПСО', url: COMPANY.site },
    ],
  },
  {
    path: '/projects',
    title: 'Наши проекты — спортивные площадки РПСО',
    description:
      'Фотографии реализованных объектов РПСО: спортивные площадки и оборудование в регионах России. Состав оборудования и сведения о поставках.',
  },
  {
    path: '/contacts',
    title: 'Контакты РПСО — запрос коммерческого предложения',
    description: `Свяжитесь с РПСО: ${COMPANY.phone}, ${COMPANY.email}. Производство: ${COMPANY.address}. Отправьте запрос на оборудование и коммерческое предложение.`,
  },
  {
    path: '/privacy',
    title: 'Политика обработки персональных данных — РПСО',
    description: 'Порядок обработки и защиты персональных данных посетителей сайта РПСО.',
    noindex: true,
  },
  {
    path: '/consent',
    title: 'Согласие на обработку персональных данных — РПСО',
    description:
      'Условия согласия на обработку персональных данных при запросе коммерческого предложения РПСО.',
    noindex: true,
  },
  {
    path: '/cookies',
    title: 'Использование файлов cookie — РПСО',
    description: 'Какие файлы cookie использует сайт РПСО, зачем и как их запретить в браузере.',
    noindex: true,
  },
];

export const getStaticSeoPage = (pathname: string) =>
  STATIC_SEO_PAGES.find((page) => page.path === (pathname.replace(/\/+$/, '') || '/'));
